module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-dialog', {
    staticClass: "media-audio-dialog",
    attrs: {
      "title": _vm.$t('title'),
      "visible": _vm.dialogVisible
    },
    on: {
      "update:visible": function($event) {
        _vm.dialogVisible = $event
      },
      "close": _vm.close
    }
  }, [_c('el-tabs', {
    attrs: {
      "header-no-margin": ""
    },
    on: {
      "tab-click": _vm.fetchData
    },
    model: {
      value: (_vm.currentTag),
      callback: function($$v) {
        _vm.currentTag = $$v
      },
      expression: "currentTag"
    }
  }, _vm._l((_vm.tags), function(tag) {
    return _c('el-tab-pane', {
      key: tag,
      staticClass: "audio-content",
      attrs: {
        "label": _vm.$t(("tags." + tag)),
        "name": tag
      }
    }, [(_vm.onUploading) ? _c('div', {
      staticClass: "audio-item uploading"
    }, [_c('div', {
      staticClass: "name"
    }, [_c('i', {
      staticClass: "ppj-icon-spinner"
    }), _vm._v(" " + _vm._s(_vm.uploadingFilename) + "\n        ")]), _vm._v(" "), _c('div', {
      staticClass: "progress",
      style: ({
        'width': _vm.progress * 0.8 + '%'
      })
    })]) : _vm._e(), _vm._v(" "), _c('el-table', {
      ref: "table",
      refInFor: true,
      staticStyle: {
        "width": "100%"
      },
      attrs: {
        "data": _vm.audios[tag],
        "show-header": false,
        "highlight-current-row": ""
      },
      on: {
        "current-change": function($event) {
          _vm.selected = $event ? $event.id : null
        }
      }
    }, [_c('el-table-column', {
      scopedSlots: _vm._u([{
        key: "default",
        fn: function(scope) {
          return [_c('div', {
            staticClass: "audio-item"
          }, [_c('i', {
            class: _vm.currentPlayIndex === scope.$index ? 'ppj-icon-play' : 'ppj-icon-music'
          }), _vm._v(" "), _c('div', {
            staticClass: "name"
          }, [_vm._v("\n                  " + _vm._s(scope.row.name) + "\n                  "), _c('span', {
            staticClass: "duration"
          }, [_vm._v("\n                    " + _vm._s(_vm.durationReadable(scope.row.duration)) + "\n                  ")])]), _vm._v(" "), _c('a', {
            directives: [{
              name: "show",
              rawName: "v-show",
              value: (tag !== "pub" && scope.row.id !== _vm.selected),
              expression: "tag !== \"pub\" && scope.row.id !== selected"
            }],
            staticClass: "btn trash",
            on: {
              "click": function($event) {
                $event.stopPropagation();
                _vm.remove(scope.$index)
              }
            }
          }, [_c('i', {
            staticClass: "ppj-icon-trash"
          })]), _vm._v(" "), _c('a', {
            directives: [{
              name: "show",
              rawName: "v-show",
              value: (_vm.currentPlayIndex !== scope.$index),
              expression: "currentPlayIndex !== scope.$index"
            }],
            staticClass: "btn",
            on: {
              "click": function($event) {
                $event.stopPropagation();
                _vm.play(scope.$index)
              }
            }
          }, [_c('i', {
            staticClass: "ppj-icon-play"
          })]), _vm._v(" "), _c('a', {
            directives: [{
              name: "show",
              rawName: "v-show",
              value: (_vm.currentPlayIndex === scope.$index),
              expression: "currentPlayIndex === scope.$index"
            }],
            staticClass: "btn",
            on: {
              "click": function($event) {
                $event.stopPropagation();
                _vm.pause()
              }
            }
          }, [_c('i', {
            staticClass: "ppj-icon-pause"
          })]), _vm._v(" "), _c('i', {
            directives: [{
              name: "show",
              rawName: "v-show",
              value: (scope.row.id === _vm.selected),
              expression: "scope.row.id === selected"
            }],
            staticClass: "ppj-icon-ok"
          })])]
        }
      }])
    }), _vm._v(" "), _c('div', {
      slot: "empty"
    }, [_c('span', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (!_vm.onUploading),
        expression: "!onUploading"
      }],
      staticClass: "empty-hint"
    }, [_vm._v(_vm._s(_vm.$t('empty')))])])], 1)], 1)
  })), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    slot: "footer"
  }, [_c('ssuploader', {
    staticClass: "uploader-btn",
    attrs: {
      "url": _vm.uploadUrl,
      "data": _vm.uploadData,
      "name": "medium[file]",
      "extensions": _vm.extensions,
      "filename": _vm.uploadingFilename,
      "progress": _vm.progress,
      "uploading": _vm.onUploading,
      "accept": _vm.accept
    },
    on: {
      "update:filename": function($event) {
        _vm.uploadingFilename = $event
      },
      "update:progress": function($event) {
        _vm.progress = $event
      },
      "update:uploading": function($event) {
        _vm.onUploading = $event
      },
      "complete": _vm.uploadComplete
    }
  }), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "text"
    },
    on: {
      "click": _vm.close
    }
  }, [_vm._v(_vm._s(_vm.$t('common.buttons.cancel')))]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.save
    }
  }, [_vm._v(_vm._s(_vm.$t('common.buttons.ok')))])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-614c1ddf"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/plugins/media/audio.dialog.vue
// module id = 927
// module chunks = 3